import { TagProps } from './Tag.typed';
import * as Styled from './Tag.styled';
import React from 'react';

export const Tag = React.forwardRef<HTMLElement, TagProps>((props, ref) => {
  const {
    leading,
    trailing,
    children,
    onClick,
    intent = 'default',
    elevated = false,
    weight = 'regular',
    as,
    ...rest
  } = props;

  const handleOnClick = (event: React.MouseEvent) => {
    event.preventDefault();
    onClick && onClick(event);
  };

  return (
    <Styled.Tag
      ref={ref}
      intent={intent}
      elevated={elevated}
      as={as || (onClick ? 'button' : 'span')}
      type={onClick ? 'button' : undefined}
      onClick={handleOnClick}
      clickable={!!onClick}
      {...rest}
    >
      {!!leading && <Styled.Leading>{leading}</Styled.Leading>}
      <Styled.Content weight={weight}>{children}</Styled.Content>
      {!!trailing && <Styled.Trailing>{trailing}</Styled.Trailing>}
    </Styled.Tag>
  );
});

export default Tag;
export type { TagProps };
